import React, { useContext, useEffect, useState } from "react";
import { createUseStyles } from "react-jss";
import { EmpdContext } from "../../Context";
import { useMsal } from '@azure/msal-react'
import useScreenScroll from "../../Hooks/useScreenScroll";
import DashboardHeader from "./DashboardHeader";
import ContentWrapper from "../ContentWrapper";
import AnnouncementsCard from "./AnnouncementsCard";
import { RotatingLines } from 'react-loader-spinner';
import NotAuthorized from "../NotAuthorized";
import DataSummaryCard from "./DataSummaryCard";
import { isProvider } from "../../utils"

const useStyles = createUseStyles({
  root: {},
  dashboardWrapper: {
    background: "#f8f8f8",
    height: "100%",
    padding: "50px 0px",
  },
  dashboardContent: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "top",
  },
  dashboardCard: {
    flexBasis: "44.5%",
  },
  icon: {
    width: 30,
    height: "auto",
    marginRight: 10,
  },
  announcementHeading: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
});

const useMyContext = () => {
    const context = useContext(EmpdContext)
    if( !context ) {
        throw new Error("No provider found for Context")
    }
    return context
}

const ProviderDashboard = () => {
  const context = useMyContext()
  const { isLoading, user, fetchProfile, addNewUser } = context
  const [ provider, setProvider ] = useState<boolean>(false)

  const { instance: msalInstance } = useMsal()

  const activeAccount = msalInstance.getActiveAccount()

  useEffect(() => {
  	const getAccount = async () => {
	    if( !activeAccount ) {
		  msalInstance.loginRedirect({
        	        authority: "https://globalempd.b2clogin.com/globalempd.onmicrosoft.com/B2C_1_EMPD_PROVIDER",
            	    state: `${window.location.origin}/provider/dashboard`,
					scopes: ['profile','openid'],
    	        })
		} else {
			const claims = activeAccount.idTokenClaims
			if( claims && claims.emails !== undefined && claims.emails[0]) {
				await addNewUser({
					type: 'provider',
					first_name: claims.given_name as string,
					last_name: claims.family_name as string,
					email_address: claims.emails[0] as string,
					city: claims.city as string,
					state_name: claims.state as string,
					zipcode: claims.postalCode as string,
					iss: claims.iss as string,
				})
				setProvider(true)
			}
		}
	}
	getAccount()
  }, [])

  useEffect(() => {
  	if( provider ) {
		fetchProfile('provider/dashboard')
	}
  }, [provider])

  useScreenScroll();
  const classes = useStyles();
  
  const render = () => {
    if( !activeAccount ) {
	  return (
	    <>
		  You will be redirected to log in in a moment
		</>
	  )
	}


    if( !isLoading && !isProvider(user) ) {
  	  return <NotAuthorized />
    }

	return (
		<div>
			<DashboardHeader />
			<div className={classes.dashboardWrapper}>
           		<ContentWrapper>
               		<div className={classes.dashboardContent}>
				  		{(isLoading) ? (
							<div className='top-center'>
       			            	<RotatingLines
	        	   		            strokeColor="#152E54"
    		           		        strokeWidth="3"
	    	           			    animationDuration="1.0"
	        	            	   	width="48"
    	        	    	        visible={true}
   	    	    		        />
							</div>
	           	    	) : (
							<DataSummaryCard />
						)}
   	    	    		<AnnouncementsCard className={classes.dashboardCard} />
       	        	</div>
           		</ContentWrapper>
        	</div>
		</div>
	);
  }

  sessionStorage.setItem('post-login-redirect-url',  `${window.location.origin}/providers/documents`);

  return (
  	<EmpdContext.Consumer>
		{() => render() }
  	</EmpdContext.Consumer>
  )
};

export default ProviderDashboard;
